/**
 * LeafNode - base class for behavior tree leaf nodes (actions, conditions).
 */

import { BehaviorNode, type BehaviorNodeOptions } from '../BehaviorNode.js';
export abstract class LeafNode extends BehaviorNode {
  constructor(options: BehaviorNodeOptions = {}) {
    super(options);
  }
}